<template>
  <div class="contain fullarch-billing">
    <el-card shadow="never">
      <div slot="header"><strong>全口充值与钱包</strong><span class="tip">全口点数独立于即刻负重；补账前向微信核实付款</span></div>
      <el-tabs v-model="tab" @tab-click="reset">
        <el-tab-pane label="充值订单" name="orders" />
        <el-tab-pane label="钱包与流水" name="wallets" />
      </el-tabs>
      <el-form :inline="true" @submit.native.prevent="reset">
        <el-form-item label="关键词"><el-input v-model.trim="keyword" clearable maxlength="128" :placeholder="tab === 'orders' ? '账号、姓名、手机号、订单号或微信交易号' : '账号、姓名或手机号'" style="width:330px" /></el-form-item>
        <el-form-item v-if="tab === 'orders'" label="状态"><el-select v-model="status" clearable placeholder="全部">
          <el-option label="待核实 / 未到账（不代表已付款）" value="UNRESOLVED" />
          <el-option v-for="(label, value) in orderStates" :key="value" :label="label" :value="value" />
        </el-select></el-form-item>
        <el-form-item><el-button type="primary" native-type="submit">查询</el-button><el-button @click="clear">重置</el-button></el-form-item>
      </el-form>
      <el-alert v-if="error" :title="error" type="error" :closable="false" show-icon />
      <el-table :key="tab" :data="items" v-loading="loading" border empty-text="暂无记录">
        <el-table-column prop="username" label="账号" min-width="130" />
        <el-table-column prop="display_name" label="用户名称" min-width="120" />
        <template v-if="tab === 'orders'">
          <el-table-column prop="order_no" label="充值订单号" min-width="230" />
          <el-table-column label="金额（元）" width="110"><template slot-scope="s">{{ money(s.row.amount_fen) }}</template></el-table-column>
          <el-table-column prop="points" label="购买点数" width="100" />
          <el-table-column label="支付状态" width="110"><template slot-scope="s">{{ orderStates[s.row.status] || s.row.status }}</template></el-table-column>
          <el-table-column label="到账状态" width="110"><template slot-scope="s">{{ s.row.credit_status === 'CREDITED' ? '已入账' : '未入账' }}</template></el-table-column>
          <el-table-column prop="provider_transaction_id" label="微信交易号" min-width="220" />
          <el-table-column label="创建时间" min-width="170"><template slot-scope="s">{{ date(s.row.created_at) }}</template></el-table-column>
          <el-table-column label="操作" width="190" fixed="right"><template slot-scope="s">
            <el-button type="text" :disabled="!!busy" @click="details(s.row, 'audit')">处理记录</el-button>
            <el-button type="text" :disabled="!!busy || s.row.status === 'CLOSED'" :loading="busy === s.row.order_no" @click="reconcile(s.row)">查单并补账</el-button>
          </template></el-table-column>
        </template>
        <template v-else>
          <el-table-column prop="available_points" label="可用点数" min-width="110" />
          <el-table-column prop="reserved_points" label="冻结点数" min-width="110" />
          <el-table-column label="更新时间" min-width="170"><template slot-scope="s">{{ date(s.row.updated_at) }}</template></el-table-column>
          <el-table-column label="操作" width="110"><template slot-scope="s"><el-button type="text" @click="details(s.row, 'ledger')">查看流水</el-button></template></el-table-column>
        </template>
      </el-table>
      <el-pagination :current-page="page" :page-size="20" :total="total" layout="total, prev, pager, next" @current-change="changePage" />
    </el-card>
    <el-dialog :title="detailTitle" :visible.sync="dialog" width="90%" @closed="closeDetails">
      <el-alert v-if="detailKind === 'audit'" title="这里只记录人工查单补账。处理中不代表未到账；请求中断时应重新查单确认，系统会防止重复入账。" type="info" :closable="false" />
      <el-alert v-if="detailError" :title="detailError" type="error" :closable="false" />
      <el-table :key="detailKind" :data="detailItems" v-loading="detailLoading" border empty-text="暂无记录">
        <el-table-column label="时间" min-width="170"><template slot-scope="s">{{ date(s.row.created_at) }}</template></el-table-column>
        <template v-if="detailKind === 'audit'">
          <el-table-column prop="actor_id" label="管理员ID" min-width="130" />
          <el-table-column prop="reason" label="处理原因" min-width="180" />
          <el-table-column label="处理状态" width="110"><template slot-scope="s">{{ auditStates[s.row.status] || s.row.status }}</template></el-table-column>
          <el-table-column label="处理结果" min-width="180"><template slot-scope="s">{{ results[s.row.result_code] || s.row.result_code || '等待确认' }}</template></el-table-column>
        </template>
        <template v-else>
          <el-table-column label="类型" width="100"><template slot-scope="s">{{ entryStates[s.row.entry_type] || s.row.entry_type }}</template></el-table-column>
          <el-table-column prop="available_delta" label="可用变化" width="100" />
          <el-table-column prop="reserved_delta" label="冻结变化" width="100" />
          <el-table-column prop="available_after" label="变动后可用" width="110" />
          <el-table-column prop="reserved_after" label="变动后冻结" width="110" />
          <el-table-column prop="biz_id" label="关联订单 / 任务" min-width="200" />
          <el-table-column prop="reason" label="原因" min-width="180" />
          <el-table-column prop="actor_id" label="操作来源" min-width="130" />
        </template>
      </el-table>
      <el-pagination :current-page="detailPage" :page-size="20" :total="detailTotal" layout="total, prev, pager, next" @current-change="changeDetailPage" />
    </el-dialog>
  </div>
</template>
<script>
import { listFullArchRecords, getFullArchDetails, reconcileFullArchOrder } from '../../assets/utils/fullArchAdminApi'
import { formatPlatformDate } from '../../assets/utils/platformDate'
export default {
  name: 'FullArchBilling',
  data () {
    return {
      tab: 'orders', keyword: '', status: '', page: 1, total: 0, items: [], loading: false, error: '', sequence: 0, busy: '',
      dialog: false, detailKind: 'audit', detailTitle: '', detailId: '', detailPage: 1, detailTotal: 0, detailItems: [], detailLoading: false, detailError: '', detailSequence: 0,
      orderStates: { CREATING: '创建中', PENDING: '待支付确认', PAID: '已支付', CLOSED: '已关闭', FAILED: '创建失败' },
      auditStates: { PROCESSING: '处理中', SUCCEEDED: '处理完成', FAILED: '处理失败' },
      entryStates: { CREDIT: '入账', RESERVE: '预占', SETTLE: '结算' },
      results: { CREDITED: '已确认付款并补账', ALREADY_CREDITED: '已到账，无需重复补账', NOT_PAID: '微信未确认支付成功', WECHAT_PAY_QUERY_UNAVAILABLE: '微信查单暂不可用', WECHAT_AMOUNT_MISMATCH: '金额不符，未补账', WECHAT_MERCHANT_MISMATCH: '商户不符，未补账', RECONCILE_FAILED: '处理失败，请核查后重试' }
    }
  },
  created () { this.load() },
  beforeDestroy () { this.sequence++; this.detailSequence++ },
  methods: {
    date: formatPlatformDate,
    money (fen) { return (Number(fen) / 100).toFixed(2) },
    reset () { this.page = 1; this.load() },
    clear () { this.keyword = ''; this.status = ''; this.reset() },
    changePage (page) { this.page = page; this.load() },
    async load () {
      const seq = ++this.sequence
      this.loading = true; this.error = ''; this.items = []; this.total = 0
      try {
        const data = await listFullArchRecords(this.tab, { keyword: this.keyword, status: this.tab === 'orders' ? this.status : '', limit: 20, offset: (this.page - 1) * 20 })
        if (seq === this.sequence) { this.items = data.items; this.total = data.total }
      } catch (e) { if (seq === this.sequence) this.error = e.message }
      finally { if (seq === this.sequence) this.loading = false }
    },
    details (row, kind) {
      this.detailKind = kind; this.detailId = kind === 'audit' ? row.order_no : row.user_id
      this.detailTitle = (kind === 'audit' ? '处理记录 · ' + row.order_no : '全口流水 · ' + row.username)
      this.detailPage = 1; this.dialog = true; this.loadDetails()
    },
    closeDetails () { this.detailSequence++; this.detailItems = [] },
    changeDetailPage (page) { this.detailPage = page; this.loadDetails() },
    async loadDetails () {
      const seq = ++this.detailSequence
      this.detailLoading = true; this.detailError = ''; this.detailItems = []; this.detailTotal = 0
      try {
        const data = await getFullArchDetails(this.detailKind, this.detailId, { limit: 20, offset: (this.detailPage - 1) * 20 })
        if (seq === this.detailSequence) { this.detailItems = data.items; this.detailTotal = data.total }
      } catch (e) { if (seq === this.detailSequence) this.detailError = e.message }
      finally { if (seq === this.detailSequence) this.detailLoading = false }
    },
    async reconcile (row) {
      if (this.busy) return
      this.busy = row.order_no
      try {
        const answer = await this.$prompt('订单：' + row.order_no + '。仅在微信确认付款后补账，请填写处理原因。', '查单并补账', {
          inputType: 'textarea', inputValidator: value => !!(value && value.trim() && value.length <= 255) || '请填写1至255字处理原因', confirmButtonText: '核实并处理', cancelButtonText: '取消'
        })
        const data = await reconcileFullArchOrder(row.order_no, answer.value.trim())
        this.$message.success(this.results[data.result] || '处理完成，请查看记录')
        await this.load(); this.details(row, 'audit')
      } catch (e) {
        if (e !== 'cancel' && e !== 'close') {
          this.$message.error(e.message || '请求未完成，请查处理记录确认结果，不要手工增加点数')
          await this.load(); this.details(row, 'audit')
        }
      } finally { this.busy = '' }
    }
  }
}
</script>
<style scoped>
.fullarch-billing { padding: 16px; }
.tip { margin-left: 16px; color: #606266; font-size: 13px; }
.el-pagination { margin-top: 18px; text-align: right; }
.el-alert { margin-bottom: 12px; }
</style>



// WEBPACK FOOTER //
// src/views/immediate-loading/fullarch-billing.vue